import { render, staticRenderFns } from "./StatementOrgDetails.vue?vue&type=template&id=700ae51a&"
import script from "./StatementOrgDetails.vue?vue&type=script&lang=js&"
export * from "./StatementOrgDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports